// Always import global layout file
import '../../styles/templates/index.css';
import Swiper, { Navigation, Pagination } from 'swiper/core';
import '../snippets/video-hero';
import '../modules/countdown';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);
import { load } from '@shopify/theme-sections';
load('*');
new Swiper('.swiper-container-3-desktop-1-mobile', {
    slidesPerView: 1.25,
    spaceBetween: 16,
    breakpoints: {
        415: {
            slidesPerView: 3
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
new Swiper('.swiper-container-1-per-view', {
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
